(function() {
    window.ViettiOverlayScrollbars = window.ViettiOverlayScrollbars || {};

    window.ViettiOverlayScrollbars['init'] = function() {
        document.querySelectorAll('.vietti__scrollbar')
        .forEach((element) => {
            if(OverlayScrollbarsGlobal) {
                OverlayScrollbarsGlobal.OverlayScrollbars(element, {
                    overflow: {
                        x: 'hidden'
                    }
                }); // Add scrollbar to element
            }
        });
    };

    window.ViettiOverlayScrollbars.init();
})();